import React from 'react';
import PrimaryToolTip from '../PrimaryToolTip';

function NewMD({ styles, md, deleteSelectedMD }) {
  return (
    <div className="accordion-item mt-2">
      <h2 className="accordion-header" id="headingTwo">
        <button
          className="accordion-button collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#collapseTwo"
          aria-expanded="false"
          aria-controls="collapseTwo"
        >
          {Array.isArray(md) && md[0].md_profile.last_name}
          {Array.isArray(md) && md[0].md_profile.first_name}
        </button>
      </h2>
      <div
        id="collapseTwo"
        className="accordion-collapse collapse show"
        aria-labelledby="headingTwo"
      >
        <div className="accordion-body">
          <div className="col-sm-12 row">
            <div className="col-sm-6" style={styles.divPadding}>
              <div className="form-group row" style={styles.formGroup}>
                <label
                  htmlFor="customer_account_name"
                  className="col-sm-4 col-form-label col-form-label-sm"
                >
                  MD Firstname
                  <span className="requiredField"> *</span>
                  <PrimaryToolTip />
                </label>
                <div
                  className="col-sm-8 row pr-0"
                  style={{
                    marginTop: '6px',
                  }}
                >
                  <div className="col-sm-11 row">
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      name="md_firstname"
                      id="md_firstname"
                      readOnly
                      defaultValue={
                        Array.isArray(md) ? md[0].md_profile.first_name : null
                      }
                    />
                  </div>
                </div>
              </div>
              {/*  */}
              <div className="form-group row" style={styles.formGroup}>
                <label
                  htmlFor="customer_account_name"
                  className="col-sm-4 col-form-label col-form-label-sm"
                >
                  MD Lastname
                  <span className="requiredField"> *</span>
                  <PrimaryToolTip />
                </label>
                <div
                  className="col-sm-8 row pr-0"
                  style={{
                    marginTop: '6px',
                  }}
                >
                  <div className="col-sm-11 row">
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      name="md_lastname"
                      id="md_lastname"
                      readOnly
                      defaultValue={
                        Array.isArray(md) ? md[0].md_profile.last_name : null
                      }
                    />
                  </div>
                </div>
              </div>
              {/*  */}
              {/*  */}
              <div className="form-group row" style={styles.formGroup}>
                <label
                  htmlFor="md_contact_no"
                  className="col-sm-4 col-form-label col-form-label-sm"
                >
                  Contact Number
                  <span className="requiredField"> *</span>
                  <PrimaryToolTip />
                </label>
                <div
                  className="col-sm-8 row pr-0"
                  style={{
                    marginTop: '6px',
                  }}
                >
                  <div className="col-sm-11 row">
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      name="md_contact_no"
                      id="md_contact_no"
                      readOnly
                      defaultValue={
                        Array.isArray(md) ? md[0].md_profile.contact_no : null
                      }
                    />
                  </div>
                </div>
              </div>
              {/*  */}
              {/*  */}
              <div className="form-group row" style={styles.formGroup}>
                <label
                  htmlFor="md_email"
                  className="col-sm-4 col-form-label col-form-label-sm"
                >
                  Email
                  <span className="requiredField"> *</span>
                  <PrimaryToolTip />
                </label>
                <div
                  className="col-sm-8 row pr-0"
                  style={{
                    marginTop: '6px',
                  }}
                >
                  <div className="col-sm-11 row">
                    <input
                      type="email"
                      className="form-control form-control-sm"
                      name="md_email"
                      id="md_email"
                      readOnly
                      defaultValue={
                        Array.isArray(md) ? md[0].md_profile.email : null
                      }
                    />
                  </div>
                </div>
              </div>
              {/*  */}
            </div>
            {/* bottom col 6 */}
            <div className="col-sm-6" style={styles.divPadding}>
              <div className="form-group row " style={styles.formGroup}>
                <label
                  htmlFor="contact_person"
                  className="col-sm-4 col-form-label col-form-label-sm"
                >
                  Contact Person
                  <span className="requiredField"> *</span>
                  <PrimaryToolTip />
                </label>
                <div
                  className="col-sm-8 row pr-0"
                  style={{
                    marginTop: '6px',
                  }}
                >
                  <div className="col-sm-11 row">
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      name="contact_person"
                      id="contact_person"
                      readOnly
                      defaultValue={
                        Array.isArray(md)
                          ? md[0].md_profile.contact_person_name
                          : null
                      }
                    />
                  </div>
                </div>
              </div>
              {/*  */}

              <div className="form-group row" style={styles.formGroup}>
                <label
                  htmlFor="contact_person_number"
                  className="col-sm-4 col-form-label col-form-label-sm"
                >
                  Contact Number
                  <span className="requiredField"> *</span>
                  <PrimaryToolTip />
                </label>
                <div
                  className="col-sm-8 row pr-0"
                  style={{
                    marginTop: '6px',
                  }}
                >
                  <div className="col-sm-11 row">
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      name="contact_person_number"
                      id="contact_person_number"
                      readOnly
                      defaultValue={
                        Array.isArray(md)
                          ? md[0].md_profile.contact_person_contact_no
                          : null
                      }
                    />
                  </div>
                </div>
              </div>
              {/*  */}

              <div className="form-group row" style={styles.formGroup}>
                <label
                  htmlFor="contact_person_email"
                  className="col-sm-4 col-form-label col-form-label-sm"
                >
                  Email
                  <span className="requiredField"> *</span>
                  <PrimaryToolTip />
                </label>
                <div
                  className="col-sm-8 row pr-0"
                  style={{
                    marginTop: '6px',
                  }}
                >
                  <div className="col-sm-11 row">
                    <input
                      type="email"
                      className="form-control form-control-sm"
                      name="contact_person_email"
                      id="contact_person_email"
                      readOnly
                    />
                  </div>
                </div>
              </div>
              {/*  */}
            </div>
            {/*  */}

            {/* Address Section */}
            <div className="col-sm-12" style={styles.divPadding}>
              <section style={styles.fieldset}>
                <legend
                  style={{ ...styles.legend, backgroundColor: '#f4f6fa' }}
                >
                  Address
                </legend>
                <div className="col-sm-12 row mt-4">
                  <div className="form-group row" style={styles.formGroup}>
                    <label
                      htmlFor="bldg_street_address"
                      className="col-sm-2 col-form-label col-form-label-sm"
                    >
                      Bldg & Street Address
                      <span className="requiredField"> *</span>
                      <PrimaryToolTip />
                    </label>
                    <div className="col-sm-9 row ">
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        name="bldg_street_address"
                        id="bldg_street_address"
                        readOnly
                        defaultValue={
                          Array.isArray(md) ? md[0].md_profile.address : null
                        }
                      />
                    </div>
                  </div>
                </div>
                {/* SM-12 */}
                <div className="col-sm-12 row">
                  <div className="col-sm-6" style={styles.divPadding}>
                    <div className="form-group row " style={styles.formGroup}>
                      <label
                        htmlFor="brgy"
                        className="col-sm-4 col-form-label col-form-label-sm"
                      >
                        Barangay
                        <span className="requiredField"> *</span>
                        <PrimaryToolTip />
                      </label>
                      <div
                        className="col-sm-8 row pr-0"
                        style={{
                          marginTop: '6px',
                        }}
                      >
                        <div className="col-sm-11 row">
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            name="brgy"
                            id="brgy"
                            readOnly
                          />
                        </div>
                      </div>
                    </div>
                    {/*  */}
                    <div className="form-group row" style={styles.formGroup}>
                      <label
                        htmlFor="city"
                        className="col-sm-4 col-form-label col-form-label-sm"
                      >
                        City
                        <span className="requiredField"> *</span>
                        <PrimaryToolTip />
                      </label>
                      <div
                        className="col-sm-8 row pr-0"
                        style={{
                          marginTop: '6px',
                        }}
                      >
                        <div className="col-sm-11 row">
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            name="city"
                            id="city"
                            readOnly
                          />
                        </div>
                      </div>
                    </div>
                    {/*  */}
                    {/*  */}
                    <div className="form-group row" style={styles.formGroup}>
                      <label
                        htmlFor="province"
                        className="col-sm-4 col-form-label col-form-label-sm"
                      >
                        Province
                        <span className="requiredField"> *</span>
                        <PrimaryToolTip />
                      </label>
                      <div
                        className="col-sm-8 row pr-0"
                        style={{
                          marginTop: '6px',
                        }}
                      >
                        <div className="col-sm-11 row">
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            name="province"
                            id="province"
                            readOnly
                          />
                        </div>
                      </div>
                    </div>
                    {/*  */}
                    {/*  */}
                    <div className="form-group row" style={styles.formGroup}>
                      <label
                        htmlFor="zip_code"
                        className="col-sm-4 col-form-label col-form-label-sm"
                      >
                        Zip Code
                        <span className="requiredField"> *</span>
                        <PrimaryToolTip />
                      </label>
                      <div
                        className="col-sm-8 row pr-0"
                        style={{
                          marginTop: '6px',
                        }}
                      >
                        <div className="col-sm-11 row">
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            name="zip_code"
                            id="zip_code"
                            readOnly
                          />
                        </div>
                      </div>
                    </div>
                    {/*  */}
                  </div>
                  {/* bottom col 6 */}
                  <div className="col-sm-6" style={styles.divPadding}>
                    <div className="form-group row " style={styles.formGroup}>
                      <label
                        htmlFor="lba_code"
                        className="col-sm-4 col-form-label col-form-label-sm"
                      >
                        LBA Code
                        <span className="requiredField"> *</span>
                        <PrimaryToolTip />
                      </label>
                      <div
                        className="col-sm-8 row pr-0"
                        style={{
                          marginTop: '6px',
                        }}
                      >
                        <div className="col-sm-11 row">
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            name="lba_code"
                            id="lba_code"
                            readOnly
                          />
                        </div>
                      </div>
                    </div>
                    {/*  */}

                    <div className="form-group row" style={styles.formGroup}>
                      <label
                        htmlFor="lba_name"
                        className="col-sm-4 col-form-label col-form-label-sm"
                      >
                        LBA Name
                        <span className="requiredField"> *</span>
                        <PrimaryToolTip />
                      </label>
                      <div
                        className="col-sm-8 row pr-0"
                        style={{
                          marginTop: '6px',
                        }}
                      >
                        <div className="col-sm-11 row">
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            name="lba_name"
                            id="lba_name"
                            readOnly
                          />
                        </div>
                      </div>
                    </div>
                    {/*  */}

                    <div className="form-group row" style={styles.formGroup}>
                      <label
                        htmlFor="district"
                        className="col-sm-4 col-form-label col-form-label-sm"
                      >
                        District
                        <span className="requiredField"> *</span>
                        <PrimaryToolTip />
                      </label>
                      <div
                        className="col-sm-8 row pr-0"
                        style={{
                          marginTop: '6px',
                        }}
                      >
                        <div className="col-sm-11 row">
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            name="district"
                            id="district"
                            readOnly
                          />
                        </div>
                      </div>
                    </div>
                    {/*  */}
                  </div>
                  {/*  */}

                  {/* End of Address Section */}
                </div>
                {/* END SM-12 */}
              </section>
            </div>
            {/* End of Address Section */}

            <div className="col-sm-12 d-flex justify-content-center mt-3">
              <button className="btn btn-danger" onClick={deleteSelectedMD}>
                Remove MD
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NewMD;
